/**
 * Turns an http(s) URL inside plain text into a clickable link — opened email
 * bodies, text/voicemail transcript bubbles, and notes all show raw text
 * today, so a ServiceTitan estimate link (or anything else) sits inert and
 * can overflow a narrow card. Never any other scheme (`mailto:`, `tel:`, a
 * bare domain with no protocol): matching those too would turn ordinary
 * prose into links by accident.
 */
import type { ReactNode } from "react";

import { splitLinks } from "./tickets";

/** Trailing sentence punctuation and a wrapping paren stay out of the href —
 *  `splitLinks` owns that rule. */
export function linkifyText(text: string): ReactNode {
  const segments = splitLinks(text);
  if (!segments.some((s) => s.kind === "link")) return text;
  return segments.map((s, i) =>
    s.kind === "text" ? (
      s.text
    ) : (
      <a
        key={i}
        href={s.href}
        target="_blank"
        rel="noopener noreferrer"
        className="break-all text-primary underline"
      >
        {s.text}
      </a>
    ),
  );
}
